<template>
  <!--Binds the color for the variant of the icon based on the status from nereus-->
  <!--Hover text that displays what the status is from nereus-->
  <b-badge
    class="icon-badge"
    :variant="getStatusHelper()"
    pill
  >
    <a
      :href="`${nereus_url}`"
      target="_blank"
    >
      <i
        v-if="iconValue"
        class="material-icons icon-color"
        aria-hidden="true"
        role="presentation"
        v-b-popover.hover.bottom="getStatusIndicatorText()"
      >{{getStatusIndicatorIcon()}}</i>
    </a>
  </b-badge>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import { iconNames } from '../../utils/constants';

export default {
  props: ['infraRD'],
  data() {
    return {
      nereus_url: `${process.env.NEREUS}/help/codes`,
      iconValue: true, // sets the light colored icons
      iconNames,
    };
  },
  computed: {
    ...mapState({
      infraIndicators: (state) => state.infraIndicators,
    }),
  },
  methods: {
    // Helper method to filter through the statusIndicator information
    getStatusHelper() {
      const infraSubstring = this.infraRD.slice(9, 14);
      let statusValue = _.get(this.infraIndicators, infraSubstring);
      if (_.isEmpty(statusValue)) {
        statusValue = 'unset';
      }
      return statusValue.toLowerCase();
    },
    // Takes the status information and displays "Status" text
    getStatusIndicatorText() {
      const statusHolderText = this.getStatusHelper();
      const newStr = statusHolderText.replace(/-|_/g, ' ');
      let text;
      if (_.isEmpty(statusHolderText)) {
        text = 'No status available';
      } else {
        text = newStr[0].toUpperCase() + newStr.substring(1);
      }
      return text;
    },
    // Takes the status information and displays "Status" text
    getStatusIndicatorIcon() {
      const statusHolder = this.getStatusHelper();
      return this.iconNames[statusHolder];
    },
  },
};
</script>

<style>
.icon-badge {
  padding-right: 0.3em !important;
  padding-left: 0.3em !important;
}
.icon-color {
  color: white !important;
  font-size: 1rem !important;
}
/* Different variants for the badge based on status frorm nereus */
.badge-operational {
  background-color: #00923a !important;
}
.badge-uncabled {
  background-color: #bdbdbd !important;
}
.badge-partiallyFunctional {
  background-color: #ff6e40 !important;
}
.badge-troubleshooting {
  background-color: #fbc02d !important;
}
.badge-data_quality {
  background-color: #f57c00 !important;
}
.badge-failed {
  background-color: #c10015 !important;
}
.badge-offline {
  background-color: #9e9e9e !important;
}
.badge-not_deployed {
  background-color: #424242 !important;
}
.badge-unset {
  background-color: #9e9e9e !important;
}
.badge-default {
  background-color: #000000 !important;
}
</style>
